// extracted by mini-css-extract-plugin
export var background = "_62-0";
export var container = "_62-1";
export var contentItem = "_62-7";
export var extendedWarranty = "_62-5";
export var link = "_62-d";
export var modal = "_62-b";
export var modalCloseButton = "_62-9";
export var modalContent = "_62-3";
export var modalContentMain = "_62-6";
export var modalImageLogo = "_62-8";
export var modalLogo = "_62-a";
export var modalSideImage = "_62-4";
export var preview = "_62-c";
export var redoModal = "_62-2";